import PropTypes from 'prop-types';

import * as utils from '../../../utils';
import {
	CustomTypes,
	DropdownTypes,
	TextboxTypes,
	// UpmcEsoSearch ,
	ValidationTextbox,
} from '../../../components/UI/Input';
import UpmcEsoSearch from './UpmcEsoSearch';
import { Headline6 } from '../../../components/UI/MDC/Typography/Typography';
import classes from '../UserAccessReview.module.scss';
import YesNoRadioButton from './YesNoRadioButton';
import ValidationDropdown from './ValidationDropdown';
import ValidationCheckboxList from './ValidationCheckboxList';
import { upmcEsoSearchPropTypes } from './UpmcEsoSearch';

const FormEntry = props => {
	const {
		entryKey,
		formDetails,
		inputType,
		placeholder,
		handleChange,
		searchChange,
		validateChange,
	} = props;

	let input = null;
	switch (props.inputType) {
		case DropdownTypes.DROPDOWN:
			input = (
				<ValidationDropdown
					entryKey={entryKey}
					formDetails={formDetails}
					placeholder={inputType}
					handleChange={handleChange}
					onBlur={validateChange}
					valid={
						formDetails.validation && formDetails.validation.valid
					}
					validationMessage={
						formDetails.validation && formDetails.validation.message
							? formDetails.validation.message
							: ''
					}
					disabled={props.readOnly}
					className={utils.concatenateClassNames(
						['edit-input__dropdown'],
						classes
					)}
				/>
			);
			break;
		case 'YesNoRadioButton':
			input = (
				<YesNoRadioButton
					id={entryKey}
					name={entryKey}
					onChange={handleChange}
					onBlur={validateChange}
					className={utils.concatenateClassNames(
						['edit-input__textbox'],
						classes
					)}
					value={formDetails.value}
					placeholder={placeholder}
					valid={
						formDetails.validation && formDetails.validation.valid
					}
					validationMessage={
						formDetails.validation && formDetails.validation.message
							? formDetails.validation.message
							: ''
					}
					disabled={props.readOnly}
				/>
			);
			break;
		case CustomTypes.UPMCESOSEARCH:
			input = (
				<UpmcEsoSearch
					id={entryKey}
					name={entryKey}
					onChange={handleChange}
					onSearch={searchChange}
					onClear={props.clearChange}
					className={utils.concatenateClassNames(
						['edit-input__textbox'],
						classes
					)}
					value={formDetails.value}
					placeholder={placeholder}
					valid={
						formDetails.validation && formDetails.validation.valid
					}
					validationMessage={
						formDetails.validation && formDetails.validation.message
							? formDetails.validation.message
							: ''
					}
					disabled={props.readOnly}
					formDetails={formDetails}
					searchResults={props.searchResults}
				/>
			);
			break;
		case 'CHECKBOX_LIST':
			input = (
				<ValidationCheckboxList
					entryKey={entryKey}
					formDetails={formDetails}
					handleChange={handleChange}
					onBlur={validateChange}
					valid={
						formDetails.validation && formDetails.validation.valid
					}
					validationMessage={
						formDetails.validation && formDetails.validation.message
							? formDetails.validation.message
							: ''
					}
					disabled={props.readOnly}
					className={utils.concatenateClassNames(
						['edit-input__dropdown'],
						classes
					)}
				/>
			);
			break;
		case 'SUMMARY':
			let value = formDetails.value;
			if (Array.isArray(formDetails.value)) {
				value = formDetails.value.join(', ');
			}
			input = (
				<Headline6
					className={utils.concatenateClassNames(
						['edit-input__label--small'],
						classes
					)}
				>
					{' '}
					{value}
				</Headline6>
			);
			break;
		case TextboxTypes.AUTOCOMPLETE:
			input = (
				<ValidationTextbox
					id={entryKey}
					type={inputType}
					name={entryKey}
					formDetails={formDetails}
					onChange={handleChange}
					onBlur={validateChange}
					className={utils.concatenateClassNames(
						['edit-input__textbox'],
						classes
					)}
					value={formDetails.value}
					placeholder={placeholder}
					valid={
						formDetails.validation && formDetails.validation.valid
					}
					validationMessage={
						formDetails.validation && formDetails.validation.message
							? formDetails.validation.message
							: ''
					}
					disabled={props.readOnly}
				/>
			);
			break;
		default:
			input = (
				<ValidationTextbox
					id={entryKey}
					type={inputType}
					name={entryKey}
					formDetails={formDetails}
					onChange={handleChange}
					onBlur={validateChange}
					className={utils.concatenateClassNames(
						['edit-input__textbox'],
						classes
					)}
					value={formDetails.value}
					placeholder={placeholder}
					valid={
						formDetails.validation && formDetails.validation.valid
					}
					validationMessage={
						formDetails.validation && formDetails.validation.message
							? formDetails.validation.message
							: ''
					}
					disabled={props.readOnly}
				/>
			);
			break;
	}

	return formDetails ? (
		<div
			className={utils.concatenateClassNames(
				['edit-input__group'],
				classes
			)}
		>
			<div
				className={utils.concatenateClassNames(
					['edit-input__group--label'],
					classes
				)}
			>
				<label
					htmlFor={entryKey}
					className={utils.concatenateClassNames(
						['edit-input__label--textbox'],
						classes
					)}
				>
					<Headline6
						className={utils.concatenateClassNames(
							['edit-input__label--small'],
							classes
						)}
					>
						{formDetails.validation &&
						formDetails.validation.rules &&
						formDetails.validation.rules.required ? (
							<span className={classes['validation--required']}>
								*{' '}
							</span>
						) : (
							<span>&nbsp;&nbsp;</span>
						)}
						{formDetails.label}
					</Headline6>
				</label>
			</div>
			{input}
		</div>
	) : null;
};

export default FormEntry;

/*
TODO:
- only pass the form object rather than the entire form state
- add prop type (custom) for the object shape
    {
        label:
        value:
        validation: {}
    }
*/

FormEntry.propTypes = {
	clearChange: PropTypes.func,
	entryKey: PropTypes.string,
	formDetails: PropTypes.shape({
		label: PropTypes.string,
		options: PropTypes.arrayOf(
			PropTypes.shape({
				checked: PropTypes.bool,
				key: PropTypes.string,
				value: PropTypes.string,
			})
		),
		settings: PropTypes.shape({
			autocomplete: PropTypes.func,
			type: PropTypes.string,
		}),
		validation: PropTypes.shape({
			message: PropTypes.string,
			required: PropTypes.bool,
			rules: PropTypes.shape({
				required: PropTypes.bool,
				maxLength: PropTypes.number,
			}),
			touched: PropTypes.bool,
			valid: PropTypes.bool,
		}),
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	}),
	handleChange: PropTypes.func,
	inputType: PropTypes.string,
	placeholder: PropTypes.string,
	readOnly: PropTypes.bool,
	searchChange: PropTypes.string,
	searchResults: upmcEsoSearchPropTypes.searchResults,
	validateChange: PropTypes.func,
};
